import { Outlet } from 'react-router-dom';
import { SiteNav } from '../../navigation/SiteNav';
import { SiteFooter } from '../../navigation/SiteFooter';
import styles from './LegalLayout.module.css';

export function LegalLayout() {
  return (
    <div className={styles.root}>
      <SiteNav />
      <main className={styles.main}>
        <Outlet context={{ innerClass: styles.inner, sidebarClass: styles.sidebar, contentClass: styles.content }} />
      </main>
      <SiteFooter />
    </div>
  );
}
